import dynamic from 'next/dynamic';
export const ButtonScrollTo = dynamic(() => import('./ScrollToWrapper'));
export { default } from './ScrollToWrapper';
